export default {
  itemsPerPage: [
    {
      value: 5
    },
    {
      value: 6
    },
    {
      value: 10
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/tables/vuetable-2/data/items-per-page-definition.js